import { render, staticRenderFns } from "./DRectangle.vue?vue&type=template&id=543f7e7a&scoped=true"
import script from "./DRectangle.vue?vue&type=script&lang=js"
export * from "./DRectangle.vue?vue&type=script&lang=js"
import style0 from "./DRectangle.vue?vue&type=style&index=0&id=543f7e7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543f7e7a",
  null
  
)

export default component.exports